<template>
  <div class="p-grid">
    <div class="p-col-12 p-xl-6">
      <div class="p-grid">
        <div class="p-col-12">
          <span>Text Color</span>
        </div>
        <div class="p-col-12">
          <ColorPicker v-model="textColor" />
        </div>
      </div>
    </div>
    <div class="p-col-12 p-xl-6">
      <div class="p-col-12">
        <span>Background Color</span>
      </div>
      <div class="p-col-12">
        <ColorPicker v-model="backgroundColor" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
@Options({})
export default class Color extends Base {
  public textColor = "#FD8C99";
  public backgroundColor = "#FFED54";
}
</script>
